const ValidateMixin = {
    props: {
        isRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        isEnabled: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            isError: false
        }
    },

    computed: {
        validatedValue() {
            return this.value
        }
    },

    mounted() {
        if (this.validatedValue === 'undefined') {
            console.error('The prop value of ValidateMixin is not defined in the component extending the mixin.')
        }
    },

    methods: {
        getValidationConstraints() {
            console.error('The method getValidationConstraints() of ValidateMixin is not defined in the component extending the mixin.')

            // return [
            //     this.validateAgainstRequired(),
            //     this.validateAgainstMinLength(<number>),
            //     this.validateAgainstEmailRegex(),
            //     this.validateAgainstPhoneRegex(),
            //     this.validateAgainstPostCodeRegex()
            // ]
            
            return []
        },

        validate() {
            this.isError = false

            this.getValidationConstraints().forEach(v => {
                if (v != true) {
                    this.isError = true
                    return
                }
            })
    
            return !this.isError
        },

        validateAgainstRequired() {
            return !this.isEnabled || !this.isRequired || (this.validatedValue && this.validatedValue.toString().length > 0)
        },

        validateAgainstAnyValue() {
            return !this.isEnabled || !this.isRequired || (this.validateValue !== undefined && this.validateValue.toString().length > 0) || this.validateValue !== 'null'
        },

        validateAgainstMinLength(minLength) {
            return !this.validatedValue || this.validatedValue.length >= minLength
        },

        validateAgainstEmailRegex() {
            if (this.validatedValue && this.validatedValue.length > 0) {
                let expr = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return expr.test(this.validatedValue)
            }
    
            return true
        },

        validateAgainstNumberRegex() {
            if (this.validatedValue && this.validatedValue.length > 0) {
                let expr = /^[0-9]+$/g
                return expr.test(this.validatedValue)
            }
    
            return true
        },

        validateAgainstPhoneRegex() {
            if (this.validatedValue && this.validatedValue.length > 0) {
                let expr = /^([0-9][0-9][0-9])\s([0-9][0-9][0-9])\s([0-9][0-9][0-9])$/
                return expr.test(this.validatedValue)
            }
    
            return true
        },

        validateAgainstPostCodeRegex() {
            if (this.validatedValue && this.validatedValue.length > 0) {
                let expr = /^\d{2}-\d{3}$/
                return expr.test(this.validatedValue)
            }
    
            return true
        }
    }
}

export default ValidateMixin